import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon, TaskIcon } from '../icons';

interface TaskDetailBreadcrumbsProps {
  taskTitle: string;
}

const TaskDetailBreadcrumbs: React.FC<TaskDetailBreadcrumbsProps> = ({ taskTitle }) => {
  const navigate = useNavigate();

  return (
    <div className="breadcrumbs">
      <button className="breadcrumb-item" onClick={() => navigate('/dashboard')}>
        <HomeIcon size={16} />
        <span>Главная</span>
      </button>
      <ChevronRightIcon size={16} />
      <button className="breadcrumb-item" onClick={() => navigate('/dashboard')}>
        <TaskIcon size={16} />
        <span>Задачи</span>
      </button>
      <ChevronRightIcon size={16} />
      <span className="breadcrumb-item current">{taskTitle}</span>
    </div>
  );
};

export default TaskDetailBreadcrumbs; 